import { connect } from "react-redux";
import { SingleSelectColor as Component } from "../SingleSelectColor";
import { cscqSubmit } from "@learningblocks/exp-redux";
import { cscqSelectOption } from "@learningblocks/exp-redux";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    selectOption: (params) => {
      dispatch(cscqSelectOption(params));
    },
    submitAnswer: (id) => {
      dispatch(cscqSubmit(id));
    },
  };
}
export const SingleSelectColorRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
